import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: registration => {
    console.log('Service worker update detected');
    // Notify user
    window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
  },
  onSuccess: registration => {
    console.log('Service worker registered successfully');
  }
});

reportWebVitals();